<template>
  <v-app id="app">
    <v-app-bar app color="rgba(189,16,32)" v-if="checkIfInIframe()">
      <img
        class="ma-3"
        :src="require('/public/ingesa_logo_weiss_png.png')"
        height="40"
      />
      <v-spacer></v-spacer>
      <v-btn text to="/address-mutation">Adressänderung</v-btn>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  methods: {
    checkIfInIframe() {
      return window.self == window.top
    },
  },
}
</script>

<style>
@import '~vuetify/dist/vuetify.min.css';
@import '../styles/base.scss';
</style>
